import api from './api';

const createSurveyResponses = query => api.post('/api/survey-responses/', { ...query });

export default {
  createSurveyResponses,
};
